import { render, staticRenderFns } from "./structType.vue?vue&type=template&id=611a33ad&scoped=true&"
import script from "./structType.vue?vue&type=script&lang=js&"
export * from "./structType.vue?vue&type=script&lang=js&"
import style0 from "./structType.vue?vue&type=style&index=0&id=611a33ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611a33ad",
  null
  
)

export default component.exports